import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Upload } from "@mui/icons-material";
import { UploadProduct } from "types/products";
import ProductPreview from "pages/SelfServe/sharedComponents/ProductPreview";

interface ProductCatalogSectionProps {
  products: UploadProduct[];
  onUpdate: (index: number, product: UploadProduct) => void;
  onDelete: (index: number) => void;
  onReUpload: () => void;
}

export const ProductCatalogSection: React.FC<ProductCatalogSectionProps> = ({
  products,
  onUpdate,
  onDelete,
  onReUpload,
}) => {
  return (
    <Box sx={{ mb: 5 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1, fontSize: 22 }}>
        Your Product Catalog
      </Typography>

      <ProductPreview
        products={products}
        onDelete={onDelete}
        onUpdate={onUpdate}
      />

      <Button
        variant="contained"
        startIcon={<Upload />}
        onClick={onReUpload}
        sx={{
          bgcolor: "grey.900",
          color: "white",
          px: 3,
          py: 1,
          fontWeight: 600,
          "&:hover": { bgcolor: "grey.800" },
        }}
      >
        Re-Upload
      </Button>
    </Box>
  );
};
